module.exports = __webpack_public_path__ + "img/fiscal_information.72e1c988.svg";